"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TablePagination = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _IconBtnTooltip = _interopRequireDefault(require("../../../IconBtnTooltip"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TablePagination = /*#__PURE__*/function (_Component) {
  _inherits(TablePagination, _Component);

  var _super = _createSuper(TablePagination);

  function TablePagination() {
    var _this;

    _classCallCheck(this, TablePagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "scrollToTableTop", function () {
      var list = document.getElementById('smartTable');
      list.scrollTop = 0;
    });

    _defineProperty(_assertThisInitialized(_this), "paginationCompose", function () {
      var _this$props$tableData = _this.props.tableData,
          rowData = _this$props$tableData.rowData,
          tableSettings = _this$props$tableData.tableSettings;
      var pageIndex = tableSettings.pageIndex,
          rowsPerPage = tableSettings.rowsPerPage;
      var filteredRowsLength = rowData.filter(function (row) {
        return row.filtered;
      }).length;
      var displayStartIndex = pageIndex * rowsPerPage;
      var displayEndIndex = displayStartIndex + (rowsPerPage > 0 ? rowsPerPage : filteredRowsLength);
      var isPrevBtnDisabled = pageIndex === 0;
      var isNextBtnDisabled = Math.floor((filteredRowsLength - 1) / rowsPerPage) <= pageIndex;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_pagination"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_leftButtons"
      }, isPrevBtnDisabled ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        disabled: true,
        onClick: function onClick() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, "first_page")) : /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "first_page",
        onClick: function onClick() {
          _this.props.tableActions.updateTableState({
            tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
              pageIndex: 0
            })
          });

          _this.scrollToTableTop();
        },
        title: "First Page"
      }), isPrevBtnDisabled ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        disabled: true,
        onClick: function onClick() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, "keyboard_arrow_left")) : /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "keyboard_arrow_left",
        onClick: function onClick() {
          _this.props.tableActions.updateTableState({
            tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
              pageIndex: pageIndex - 1
            })
          });

          _this.scrollToTableTop();
        },
        title: "Back"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_paginationCount"
      }, "".concat((displayStartIndex + 1).toLocaleString(), " - ").concat((displayEndIndex > filteredRowsLength ? filteredRowsLength : displayEndIndex).toLocaleString()), " of ", filteredRowsLength.toLocaleString()), /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_rightButtons"
      }, isNextBtnDisabled ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        disabled: true,
        onClick: function onClick() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, "keyboard_arrow_right")) : /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "keyboard_arrow_right",
        onClick: function onClick() {
          _this.props.tableActions.updateTableState({
            tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
              pageIndex: pageIndex + 1
            })
          });

          _this.scrollToTableTop();
        },
        title: "Next"
      }), isNextBtnDisabled ? /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
        disabled: true,
        onClick: function onClick() {
          return null;
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.Icon, null, "last_page")) : /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "last_page",
        onClick: function onClick() {
          _this.props.tableActions.updateTableState({
            tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
              pageIndex: Math.max(0, Math.ceil(filteredRowsLength / rowsPerPage) - 1)
            })
          });

          _this.scrollToTableTop();
        },
        title: "Last Page"
      })));
    });

    return _this;
  }

  _createClass(TablePagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // since component is being used, turn on pagination
      this.props.tableActions.updateTableState({
        paginate: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          rowsPerPageOptions = _this$props.rowsPerPageOptions,
          _this$props$tableData2 = _this$props.tableData,
          rowData = _this$props$tableData2.rowData,
          tableSettings = _this$props$tableData2.tableSettings,
          selectEnabled = _this$props$tableData2.selectEnabled;
      var rowsPerPage = tableSettings.rowsPerPage,
          selectedRows = tableSettings.selectedRows;
      var filteredRowsLength = rowData.filter(function (row) {
        return row.filtered;
      }).length;
      return (filteredRowsLength > 10 || selectedRows.length > 0) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_container"
      }, selectEnabled && /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_selectedRowsCount"
      }, selectedRows.length > 0 && /*#__PURE__*/_react["default"].createElement("span", {
        key: "selectedRowsCount"
      }, selectedRows.length.toLocaleString(), " of ", filteredRowsLength.toLocaleString(), " selected")), filteredRowsLength > 10 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_paginationControls"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "TablePagination_rowsPerPage"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "Rows per page:"), /*#__PURE__*/_react["default"].createElement(_material.Select, {
        value: rowsPerPage,
        style: {
          width: rowsPerPage === 100 ? '85px' : '75px',
          textAlign: 'center'
        },
        onChange: function onChange(e) {
          _this2.props.tableActions.updateTableState({
            tableSettings: _objectSpread(_objectSpread({}, tableSettings), {}, {
              rowsPerPage: e.target.value,
              pageIndex: 0
            })
          });

          _this2.scrollToTableTop();
        }
      }, rowsPerPageOptions.map(function (_ref) {
        var display = _ref.display,
            value = _ref.value;
        return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
          key: value,
          value: value
        }, display);
      }))), this.paginationCompose()));
    }
  }]);

  return TablePagination;
}(_react.Component);

exports.TablePagination = TablePagination;

_defineProperty(TablePagination, "propTypes", {
  /**
  * Object that can be provided to give custom rowsPerPage options
  * If All is passed in, it must have value as -1.
  */
  rowsPerPageOptions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    display: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
    value: _propTypes["default"].number.isRequired
  }).isRequired),
  // props from TableContainer
  tableActions: _propTypes["default"].shape({
    updateTableState: _propTypes["default"].func.isRequired
  }),
  tableData: _propTypes["default"].shape({
    columns: _propTypes["default"].array.isRequired,
    rowData: _propTypes["default"].array.isRequired,
    selectEnabled: _propTypes["default"].bool.isRequired,
    tableSettings: _propTypes["default"].shape({
      pageIndex: _propTypes["default"].number.isRequired,
      rowsPerPage: _propTypes["default"].number.isRequired,
      selectedRows: _propTypes["default"].array.isRequired
    }).isRequired
  })
});

TablePagination.defaultProps = {
  rowsPerPageOptions: [{
    display: 10,
    value: 10
  }, {
    display: 25,
    value: 25
  }, {
    display: 50,
    value: 50
  }, {
    display: 100,
    value: 100
  }]
};
var _default = TablePagination;
exports["default"] = _default;